<template>
    <div v-if="!loading">
        <vue-tags-input
            v-model="tag"
            :tags="tagValue"
            :autocomplete-items="autocompleteItems"
            :add-only-from-autocomplete="true"
            @tags-changed="tagsChanged"
        />
    </div>
</template>

<script>
import http from '@/http'
import FormGroup from '@/vendor/forms/FormGroups/Horizontal/FormGroup'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
    components: {FormGroup, VueTagsInput},

    props: {
        'name': {},
        'value': {}
    },

    data() {
        return {
            tag: '',
            debounce: null,
            autocompleteItems: [],
            tags: [],

            loading: true
        }
    },

    mounted() {
        if (!this.arrayValue) {
            this.loading = false

            return
        }

        Promise.all(this.arrayValue.map(id => http.get('/api/v2/tags/' + id))).then(responses => {
            this.tags = responses.map(response => {
                return {
                    id: response.data.data.id,
                    text: response.data.data.attributes.name,
                    style: 'background-color:' + response.data.data.attributes.color + ';color:#ffffff'
                }
            })

            this.loading = false
        })
    },

    computed: {
        arrayValue() {
            if (!this.value) {
                return []
            }

            return Array.isArray(this.value) ? this.value : [this.value]
        },

        tagValue() {
            if (!this.arrayValue) {
                return []
            }

            return this.arrayValue.map(id => this.tags.find(tag => tag.id === parseInt(id)))
        }
    },

    watch: {
        tag() {
            if (this.tag.length === 0) return

            clearTimeout(this.debounce)

            this.debounce = setTimeout(() => {
                http.get('/api/v2/tags?filter[search]=' + this.tag)
                    .then(response => {
                        this.autocompleteItems = response.data.data.map(tag => {
                            return {
                                id: tag.id,
                                text: tag.attributes.name,
                                style: 'background-color:' + tag.attributes.color + ';color:#ffffff'
                            }
                        })

                        this.tags = this.tags.concat(this.autocompleteItems).filter((value, index, self) => {
                            return self.map(row => row.id).indexOf(value.id) === index
                        })
                    })
            }, 300)
        }
    },

    methods: {
        tagsChanged(value) {
            this.autocompleteItems = []

            this.$emit('input', value.map(row => row.id))
        }
    }
}
</script>
